import { AddNewButtonShell } from '@/components/RootScreenButtons/buildingBlocks/AddNewButtonShell';
import { useAppPush } from '@/hooks/useAppPush';
import useTranslation from '@/hooks/useTranslation';
import { cleanLocalStorageKey } from '@/utils/cleanLocalStorageKey';

export const AddNewPreorderButton = () => {
  const t = useTranslation();
  const { push } = useAppPush();
  return (
    <AddNewButtonShell
      onClick={() => {
        cleanLocalStorageKey('PREORDER_FORM');
        push('/preorders/new?preorderEditOrigin=root');
      }}
    >
      {t('section.ADD_NEW_PREORDER')}
    </AddNewButtonShell>
  );
};
